import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import NewSession from './pages/NewSession'
import History from './pages/History'
import SessionDetail from './pages/SessionDetail'
import Insights from './pages/Insights'
import Settings from './pages/Settings'
import Crisis from './pages/Crisis'
import Help from './pages/Help'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import NotFound from './pages/NotFound'
import { OfflineIndicator } from './components/OfflineIndicator'
import { Onboarding, useOnboarding } from './components/Onboarding'

export default function App() {
  const { showOnboarding, completeOnboarding } = useOnboarding()

  return (
    <div className="app">
      <OfflineIndicator />
      {showOnboarding && <Onboarding onComplete={completeOnboarding} />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/new" element={<NewSession />} />
        <Route path="/history" element={<History />} />
        <Route path="/session/:id" element={<SessionDetail />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/crisis" element={<Crisis />} />
        <Route path="/help" element={<Help />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  )
}
